module.exports = __webpack_public_path__ + "static/media/discord.7b566528.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/discord.png
// module id = 404
// module chunks = 0